/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function eventFire(el, etype) {

  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    var evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}


document.addEventListener("DOMContentLoaded", function () {
  const obj = function () { };


  obj.videos = function () {
    const videos = document.querySelectorAll('.hero__media > .hero__media-container > div[data-video-id]');

    if (videos) {

      for (var i = 0; i < videos.length; i++) {
        let video = videos[i];
        let videoId = video.getAttribute('data-video-id');
        let videoIframeUrl = 'https://www.youtube.com/embed/' + videoId + '?autohide=0&autoplay=1&mute=1&playlist=' + videoId + '&branding=0&cc_load_policy=0&controls=0&fs=0&iv_load_policy=3&modestbranding=1&playsinline=1&quality=hd720&rel=0&showinfo=0&wmode=opaque&enablejsapi=1&widgetid=1';
        video.innerHTML = '<iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" src="' + videoIframeUrl + '" frameborder="0"></iframe>';
      }
    }

  };
  obj.videos();


  obj.announcement = function () {
    const announcementSettings = {
      mobileItems: document.querySelector('.AnnouncementBar__Content__Mobile'),

      mobileItemsList: document.querySelectorAll('.AnnouncementBar__Content__Mobile .AnnouncementBar__Content__Column'),
      desktopItemsList: document.querySelectorAll('.AnnouncementBar__Content__Desktop .AnnouncementBar__Content__Column'),

      activeMobileItem: document.querySelector('.AnnouncementBar__Content__Mobile .AnnouncementBar__Content__Column[data-announcement-i="1"]'),
      nextMobileItem: document.querySelector('.AnnouncementBar__Content__Mobile .AnnouncementBar__Content__Column[data-announcement-i="2"]'),

      activeItemI: 0,
      nextItemI: 1
    };

    setInterval(function () {
      let itemHeight = announcementSettings.mobileItemsList[0].offsetHeight;

      if ((announcementSettings.activeItemI + 1) == announcementSettings.desktopItemsList.length) {
        announcementSettings.activeItemI = 0;

      } else {
        announcementSettings.activeItemI++;
      }

      if (announcementSettings.activeItemI == 0) {
        announcementSettings.nextItemI = 1;

      } else if (announcementSettings.activeItemI == 1) {
        announcementSettings.nextItemI = 2;

      } else if (announcementSettings.activeItemI == 2) {
        announcementSettings.nextItemI = 0;
      }

      let activeItem = document.querySelector('.AnnouncementBar__Content__Desktop .AnnouncementBar__Content__Column[data-announcement-i="' + (announcementSettings.activeItemI + 1) + '"]');
      announcementSettings.activeItem = activeItem;

      let nextItem = document.querySelector('.AnnouncementBar__Content__Desktop .AnnouncementBar__Content__Column[data-announcement-i="' + (announcementSettings.nextItemI + 1) + '"]');
      announcementSettings.nextItem = nextItem;

      announcementSettings.mobileItems.classList.add('moving');
      announcementSettings.mobileItems.style.top = -(itemHeight) + 'px';

      setTimeout(function () {
        announcementSettings.activeMobileItem.innerHTML = activeItem.innerHTML;
        announcementSettings.nextMobileItem.innerHTML = nextItem.innerHTML;

        announcementSettings.mobileItems.classList.remove('moving');
        announcementSettings.mobileItems.style.top = '0px';

        //         announcementSettings.activeMobileItem.innerHTML = announcementSettings.nextItem.innerHTML;
        //         announcementSettings.nextMobileItem.innerHTML = 'NEXT';

      }, 1000);

    }, 4500);
  };
  obj.announcement();

  obj.header = function () {
    const headerSettings = {
      footer: document.querySelector('.Drawer__Main__Footer'),
      desktopSwitchers: document.querySelector('.Header__SecondaryNav #localization_form_header'),
      sidebar: {
        currency: {
          button: document.querySelector('#sidebar-menu #localization_form_header .HorizontalList__Item > button[aria-controls="header-locale-popover-0"]'),
          originalButton: document.querySelector('#shopify-section-footer #localization_form_footer .SelectButton[aria-controls="footer-locale-popover"]')
        },
        footerButtons: document.querySelector('#sidebar-menu #localization_form_header .HorizontalList__Item > button[aria-controls="header-locale-popover-0"]')
      }
    };

    if (headerSettings.sidebar.currency.button) {

      headerSettings.sidebar.currency.button.addEventListener('click', event => {
        eventFire(headerSettings.sidebar.currency.originalButton, 'click');
      });
    }

    if (headerSettings.footer && headerSettings.desktopSwitchers) {
      headerSettings.footer.innerHTML = headerSettings.desktopSwitchers.outerHTML;
    }

    if (headerSettings.sidebar.footerButtons) {

      for (var i = 0; i < headerSettings.sidebar.footerButtons.length; i++) {
        let button = headerSettings.sidebar.footerButtons[i];

        button.addEventListener('click', event => {

          if (button.classList.contains('active')) {
            button.classList.remove('active');

          } else {
            button.classList.add('active');
          }
        });
      }
    }
  };
  obj.header();

  obj.productPage = function () {

  };
  obj.productPage();

  obj.blogPage = function () {

  };

  if (document.querySelector('body.template-page')) {
    obj.blogPage();

    let labels = document.querySelectorAll('.collapsible-trigger--inline');

    for (var i = 0; i < labels.length; i++) {
      let label = labels[i];

      label.addEventListener('click', event => {
        console.log('label', label);
        let labelText = label.nextElementSibling;

        if (label.classList.contains('is-open')) {
          label.classList.remove('is-open');
          labelText.classList.remove('is-open');

        } else {
          label.classList.add('is-open');
          labelText.classList.add('is-open');
        }
      });
    }
  }

  obj.footer = function () {
    const footerSettings = {
      labels: document.querySelectorAll('.Footer__Block--links .Footer__Title')
    };

    for (var i = 0; i < footerSettings.labels.length; i++) {
      let label = footerSettings.labels[i];

      label.addEventListener('click', event => {

        if (label.classList.contains('active')) {
          label.classList.remove('active');

        } else {
          label.classList.add('active');
        }
      });
    }
  };
  obj.footer();
});

/******************************************************************/
/* vh fix
/******************************************************************/

const setVh = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

window.addEventListener('load', setVh);
window.addEventListener('resize', setVh);


/******************************************************************/
/* scroll top
/******************************************************************/


const scrollTop = document.querySelector(".scroll-top");

if (scrollTop) {
  scrollTop.addEventListener("click", function (e) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
}